let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("SDwjL")).then(() => parcelRequire('iwjRM'));